export const DATE_FORMAT = 'DD.MM.YY'; // for ElDatePicker
export const FULL_DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_DELIMITER = '.';
